import { render, staticRenderFns } from "./EmpresaPlanoCard.vue?vue&type=template&id=718f500a"
import script from "./EmpresaPlanoCard.vue?vue&type=script&lang=js"
export * from "./EmpresaPlanoCard.vue?vue&type=script&lang=js"
import style0 from "./EmpresaPlanoCard.vue?vue&type=style&index=0&id=718f500a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports